import { render, staticRenderFns } from "./ModalEnviarMensagem.vue?vue&type=template&id=176f4517&scoped=true&"
import script from "./ModalEnviarMensagem.vue?vue&type=script&lang=js&"
export * from "./ModalEnviarMensagem.vue?vue&type=script&lang=js&"
import style0 from "./ModalEnviarMensagem.vue?vue&type=style&index=0&id=176f4517&lang=scss&scoped=true&"
import style1 from "./ModalEnviarMensagem.vue?vue&type=style&index=1&id=176f4517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176f4517",
  null
  
)

export default component.exports